import React from "react";
import { Drawer } from "antd";

const ViewReport: React.FC<any> = (props) => {
  const { handleViewReport, openUpdateModal, openUpdateData } = props;

  return (
    <Drawer
      open={openUpdateModal}
      destroyOnClose
      width={900}
      onClose={handleViewReport}
      className="addModal"
      title={`View Report`}
    >
      <pre
        style={{
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
          background: "#f5f5f5",
          padding: "1rem",
          borderRadius: "5px",
        }}
      >
        <div
          style={{
            maxHeight: "80vh",
            overflow: "auto",
            padding: "1rem",
            background: "#f8f8f8",
            borderRadius: "5px",
          }}
        >
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              fontFamily: "monospace",
              fontSize: "14px",
              lineHeight: "1.6",
            }}
          >
            {openUpdateData?.response}
          </pre>
        </div>
      </pre>
    </Drawer>
  );
};

export default ViewReport;
